export class HR_EXPERT_ROUTES {
	static ROOT: string = '/hrexperts';
	static ROOT_1: string = 'hrexperts';
	static DOCUMENTS: string = 'documents';
	static STATUTORY_REPORTS: string = 'statutory_reports';
	static STATUTORY_REPORTS_DASHBOARD: string = 'stautory_reports_dashboard';
	static GLOBAL_PARAMETERS: string = 'globalParameters';
}